import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { MessageService } from '../service/message.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthService,
    private snackbar: MessageService
) {}

intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
    .pipe(
        catchError((err: HttpErrorResponse) => {
            if ([401, 403].indexOf(err.status) !== -1) {
                this.authenticationService.logout();
                location.reload();

                this.snackbar.error('logout.unauthorized-error');
                return throwError('logout.unauthorized-error');
            }

            if ([0, 404, 500, 503].indexOf(err.status) !== -1) {
                this.snackbar.error('message.error');
                return throwError('message.error');
            }

            if ([400].indexOf(err.status) !== -1) {
                console.error('Bad request', err.error);
                return throwError(err);
            }

            const error = err.error.message || err.statusText;
            return throwError(error);
        })
    );
}
}
